/* Product image lightbox.
   Click a main gallery image to open it full size over a blurred page.
   Built against the Swiper gallery this theme uses; Dawn's own media modal
   is wired to Dawn's gallery markup, which this theme replaced. */
(function () {
  var CARET =
    '<svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" fill="currentColor"/></svg>';
  var CLOSE =
    '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M9 7.94 15.47 1.47a.75.75 0 1 1 1.06 1.06L10.06 9l6.47 6.47a.75.75 0 1 1-1.06 1.06L9 10.06l-6.47 6.47a.75.75 0 0 1-1.06-1.06L7.94 9 1.47 2.53A.75.75 0 0 1 2.53 1.47z" fill="currentColor"/></svg>';

  var box, cardEl, imgEl, capEl, prevBtn, nextBtn;
  var slides = [];
  var index = 0;
  var lastFocus = null;

  function build() {
    box = document.createElement('div');
    box.className = 'pl-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product image');
    box.innerHTML =
      '<div class="pl-lightbox__card">' +
      '<button class="pl-lightbox__close" type="button" aria-label="Close">' + CLOSE + '</button>' +
      '<button class="pl-lightbox__nav pl-lightbox__nav--prev" type="button" aria-label="Previous image">' + CARET + '</button>' +
      '<button class="pl-lightbox__nav pl-lightbox__nav--next" type="button" aria-label="Next image">' + CARET + '</button>' +
      '<figure class="pl-lightbox__figure"><img class="pl-lightbox__img" alt=""></figure>' +
      '<p class="pl-lightbox__caption"></p>' +
      '</div>';
    document.body.appendChild(box);

    cardEl = box.querySelector('.pl-lightbox__card');
    imgEl = box.querySelector('.pl-lightbox__img');
    capEl = box.querySelector('.pl-lightbox__caption');
    prevBtn = box.querySelector('.pl-lightbox__nav--prev');
    nextBtn = box.querySelector('.pl-lightbox__nav--next');

    box.querySelector('.pl-lightbox__close').addEventListener('click', close);

    // Click the image to magnify it, then move the pointer to pan. The origin
    // is set from where the click landed, so the detail under the cursor is
    // what grows.
    imgEl.addEventListener('click', function (e) {
      e.stopPropagation();
      if (imgEl.classList.contains('is-zoomed')) { resetZoom(); return; }
      setOrigin(e);
      imgEl.classList.add('is-zoomed');
    });
    imgEl.addEventListener('mousemove', function (e) {
      if (imgEl.classList.contains('is-zoomed')) setOrigin(e);
    });
    prevBtn.addEventListener('click', function () { go(index - 1); });
    nextBtn.addEventListener('click', function () { go(index + 1); });
    // Clicking the scrim closes; clicking the card must not.
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowLeft') { go(index - 1); return; }
    if (e.key === 'ArrowRight') { go(index + 1); return; }
    if (e.key === 'Tab') {
      // Keep focus inside the dialog.
      var f = box.querySelectorAll('button');
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function resetZoom() {
    if (!imgEl) return;
    imgEl.classList.remove('is-zoomed');
    imgEl.style.transformOrigin = '';
  }

  function go(i) {
    if (!slides.length) return;
    resetZoom();
    index = (i + slides.length) % slides.length;
    var src = slides[index];
    imgEl.src = src.full;
    imgEl.alt = src.alt || '';
    capEl.textContent = slides.length > 1 ? index + 1 + ' / ' + slides.length : '';
    capEl.hidden = slides.length < 2;
    prevBtn.hidden = nextBtn.hidden = slides.length < 2;
  }

  function collect(gallery) {
    return Array.prototype.map.call(
      gallery.querySelectorAll('.product__media-list .product__media-item img'),
      function (img) {
        // currentSrc is whatever the browser picked for the thumbnail size;
        // strip Shopify's width param so the lightbox gets the full asset.
        var base = img.getAttribute('src') || img.currentSrc || '';
        return { full: base.replace(/([?&])width=\d+/, '$1width=2000'), alt: img.getAttribute('alt') };
      }
    );
  }

  function open(gallery, startAt) {
    if (!box) build();
    slides = collect(gallery);
    if (!slides.length) return;
    lastFocus = document.activeElement;
    go(startAt || 0);
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    box.querySelector('.pl-lightbox__close').focus();
  }

  function setOrigin(e) {
    var r = imgEl.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100;
    var y = ((e.clientY - r.top) / r.height) * 100;
    imgEl.style.transformOrigin = x + '% ' + y + '%';
  }

  function close() {
    if (!box) return;
    resetZoom();
    box.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function bind(gallery) {
    var openers = gallery.querySelectorAll('.product__modal-opener');
    Array.prototype.forEach.call(openers, function (opener, i) {
      if (opener.dataset.plBound) return;
      opener.dataset.plBound = '1';
      opener.setAttribute('role', 'button');
      opener.setAttribute('tabindex', '0');
      opener.setAttribute('aria-label', 'Open image');

      // A drag on the slider ends in a click; only a real tap should open.
      var sx = 0, sy = 0;
      opener.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
      opener.addEventListener('click', function (e) {
        if (Math.abs(e.clientX - sx) > 6 || Math.abs(e.clientY - sy) > 6) return;
        e.preventDefault();
        var item = opener.closest('.product__media-item');
        var all = Array.prototype.slice.call(
          gallery.querySelectorAll('.product__media-list .product__media-item')
        );
        open(gallery, Math.max(0, all.indexOf(item)));
      });
      opener.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opener.click(); }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.product__media-wrapper').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
